import { useDispatch, useSelector } from 'react-redux';
import PendingCard from '@/components/Dashboard/DashboardPendings/PendingsCard';
import GenericBarChart from '../../../Charts/GenericBarChart';
import { getOverviewDevelopmentsTypes } from '@/store/slices/components/dashboard/service';
import useFetchDashboard from '@/components/Dashboard/customHooks/useFetchDashboard';
import {
  getBaseUrl,
  getParsedLabels,
  handleClickBar,
  handleTooltip,
} from './utils';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import DashboardEmptyStateCard from '@/components/Dashboard/DashboardEmptyStateCard';
import DevelopmentIcon from '@/public/images/dashboard/development.svg';
import { useTrackOverviewTab } from '@/components/Dashboard/customHooks/useTrackDashboard';

export default function DevelopmentsTypes() {
  const dispatch = useDispatch();
  const { overviewDevelopmentsTypes, miniCards } = useSelector(
    (state) => state.DashboardSlice
  );
  const track = useTrackOverviewTab();
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const { loading, hasFetched, labels, datasets } = overviewDevelopmentsTypes;
  const { developmentsValue } = miniCards;

  useFetchOnViewport(
    (query) => {
      dispatch(getOverviewDevelopmentsTypes(query));
    },
    [],
    { hasFetched }
  );

  const parsedLabels = getParsedLabels(labels, Trans(translations, 'Others'));
  const headerUrl = getBaseUrl();

  return (
    <PendingCard
      ref={ref}
      loading={loading || isStale}
      id="overview-developments"
    >
      <PendingCard.Header
        redirectUrl={developmentsValue === 0 ? null : headerUrl}
        toolTipText={Trans(translations, 'ShowAll')}
        trackCallback={(element) => track.developmentType(element)}
      >
        {Trans(translations, 'DevelopmentType')}
      </PendingCard.Header>

      {developmentsValue === 0 ? (
        <DashboardEmptyStateCard
          icon={DevelopmentIcon}
          title={Trans(
            translations,
            'HereYouWillSeeTheQuantityByDevelopmentType'
          )}
        />
      ) : (
        <GenericBarChart
          labels={parsedLabels}
          datasets={datasets}
          onBarClick={({ label }) => handleClickBar(label.typeId)}
          getTooltipLabel={(context) => handleTooltip(context, labels)}
        />
      )}
    </PendingCard>
  );
}
